import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin } from 'lucide-react';
import PartnershipDetailLayout from './PartnershipDetailLayout';

export default function AddAddressPage() {
  const { t } = useTranslation();
  return (
    <PartnershipDetailLayout
      testId="add-address-page"
      icon={MapPin}
      badgeLabel={t('partnership.addAddress.badge')}
      title={t('partnership.addAddress.title')}
      titleAccent={t('partnership.addAddress.titleAccent')}
      intro={t('partnership.addAddress.intro')}
      ctaType="add_address"
      sections={[
        {
          title: t('partnership.addAddress.s1Title'),
          paragraphs: [
            t('partnership.addAddress.s1P1'),
            t('partnership.addAddress.s1P2'),
          ],
        },
        {
          title: t('partnership.addAddress.s2Title'),
          items: [
            t('partnership.addAddress.s2I1'),
            t('partnership.addAddress.s2I2'),
            t('partnership.addAddress.s2I3'),
            t('partnership.addAddress.s2I4'),
            t('partnership.addAddress.s2I5'),
            t('partnership.addAddress.s2I6'),
            t('partnership.addAddress.s2I7'),
          ],
        },
        {
          title: t('partnership.addAddress.s3Title'),
          paragraphs: [
            t('partnership.addAddress.s3P1'),
            t('partnership.addAddress.s3P2'),
          ],
        },
        {
          title: t('partnership.addAddress.s4Title'),
          paragraphs: [
            t('partnership.addAddress.s4P1'),
            t('partnership.addAddress.s4P2'),
          ],
        },
      ]}
      faq={[
        { q: t('partnership.addAddress.faq1Q'), a: t('partnership.addAddress.faq1A') },
        { q: t('partnership.addAddress.faq2Q'), a: t('partnership.addAddress.faq2A') },
        { q: t('partnership.addAddress.faq3Q'), a: t('partnership.addAddress.faq3A') },
        { q: t('partnership.addAddress.faq4Q'), a: t('partnership.addAddress.faq4A') },
      ]}
    />
  );
}
